import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class NetworkingAdminIcon extends BaseIcon {
  getChildren = () => [
    <path fill={ this.getColor() }
          fillRule='evenodd'
          d="M1406.99,941.779v1.213h-12l0.02-1.31s1.63-2.694,4.45-2.694c0.58,0,.94,0,1.3.007-1.81-.091-2.77-1.434-2.77-3.367,0-2,0-3.626,2.96-3.626,3.13,0,3.03,1.623,3.03,3.626,0,1.947-1.04,3.3-2.88,3.37,0.37,0,.8.007,1.49,0.007C1405.36,939.005,1406.99,941.779,1406.99,941.779ZM1392,930.5a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,1392,930.5Zm7-.293v-2.276l-2.92-2.94h-3.59l-3.49,3.5v3.6l2.9,2.913h4.1c-0.01.393-.01,0.8-0.01,1.214a8.466,8.466,0,0,0,.22,1.869l-0.53.908h-2.35l-1.26-2.161L1389,938l-2.12-1.962,0.8-2.809-2.68-1.564v-2.343l2.78-1.613L1387,925l2-2,2.71,0.769,1.62-2.774h2.35l1.57,2.709,2.75-.7,2,2-1.19,3.043,2.2,1.279v0.892a9.417,9.417,0,0,0-2.08-.207A8.654,8.654,0,0,0,1399,930.2Z"
          transform="translate(-1384 -920)"/>
  ]
  getViewBox = () => '0 0 24 24'
}


